<template>
  <el-skeleton
    style="
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      opacity: 0.2;
      margin: 10px;
    "
    animated
  >
    <template #template>
      <el-skeleton-item
        variant="image"
        style="
          height: 300px;
          width: 200px;
          border-radius: 10px;
          margin-bottom: 10px;
        "
      />
      <el-skeleton-item variant="text" style="width: 100px" />
    </template>
  </el-skeleton>
</template>
<script>
export default {};
</script>
